/**
 * Own cast bar (bottom center, above action bar). Rendered only while
 * `cast` on own entity is non-null.
 */

import type { ReactElement } from "react";
import { useStore } from "../store/context.js";
import { ownEntity } from "./hud-util.js";

export function CastBar(): ReactElement | null {
  const { state } = useStore();
  const me = ownEntity(state.hudSnapshot, state.ownSeat);
  if (me === null || state.hudSnapshot === null) return null;
  const cast = me.cast;
  if (cast === null) return null;
  const total = cast.endTick - cast.startTick;
  const elapsed = state.hudSnapshot.tick - cast.startTick;
  const f = total > 0 ? Math.max(0, Math.min(1, elapsed / total)) : 0;
  return (
    <div
      data-testid="own-cast-bar"
      style={{
        position: "absolute",
        bottom: 96,
        left: "50%",
        transform: "translateX(-50%)",
        width: 200,
        height: 8,
        background: "#161c24",
        border: "1px solid #444",
        borderRadius: 3,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          width: `${f * 100}%`,
          height: "100%",
          background: "#d5a640",
        }}
      />
    </div>
  );
}
